/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGetOptions = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18.707 15.293 22.414 19l-3.707 3.707-1.414-1.414L18.585 20H15v-2h3.585l-1.292-1.293zM20 2v11h-2V4H4v16h9v2H2V2zM8 11v2H6v-2zm8 0v2h-6v-2zM8 7v2H6V7zm8 0v2h-6V7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGetOptions as GetOptions };
